/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refusal_Too_LargeInputs */



/**
* | output |
* | --- |
* | "That's more than can be saved at once. Shorten it and try again." |
*
* @param {Refusal_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_too_large = /** @type {((inputs?: Refusal_Too_LargeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Too_LargeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это слишком много для одного сохранения. Сократите и попробуйте снова.")
	return /** @type {LocalizedString} */ ("That's more than can be saved at once. Shorten it and try again.")
});